import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableVehiculeCreatePage = withAsyncLoading(async () =>
    import('./VehiculeCreatePage').then((res) => res.VehiculeCreatePage)
);

export { LoadableVehiculeCreatePage };
